module.exports = __webpack_public_path__ + "static/media/RightArrow.21d332ea.svg";